import React, { Fragment, useRef } from 'react';
import { translate } from '../../Services/translation';
import { Warning } from 'phosphor-react';

const QuickOrderAutoComplete = (props) => {
  const { queryResult, isLoading, onItemSelected } = props;
  const items = queryResult ? queryResult.articles : null;

  return (
    <div className="quick-order__auto-complete">
      <div className="quick-order__auto-complete-items">
        {!isLoading &&
          items &&
          items.length > 0 &&
          items.map((item, index) => (
            <Fragment key={'ac' + index + item.articleNumber}>
              <div
                className={`quick-order__ac-item ${
                  !item.availableForQuickOrder &&
                  'quick-order__ac-item--not-avalible'
                }`}
                onClick={() => onItemSelected(item)}
              >
                <div className="quick-order__ac-image">
                  {item.imageUrl && <img src={item.imageUrl} loading="lazy" />}
                </div>
                <div className="quick-order__ac-article-number text-medium">
                  {item.articleNumber}
                </div>
                <div
                  className={`quick-order__ac-name ${
                    !item.availableForQuickOrder && 'color-grey-500'
                  }`}
                >
                  {item.name}
                </div>
              </div>
              {!item.availableForQuickOrder && (
                <div className="quick-order__ac-not-avalible text-xsmall bold color-error-700">
                  <>
                    <Warning size={16} />{' '}
                    {translate('quickorder.not-available')}
                  </>
                </div>
              )}
            </Fragment>
          ))}
        {!isLoading && items && items.length == 0 && (
          <div className="quick-order__ac-no-hits text-medium bold color-grey-900">
            {translate('quickorder.no-matching-articles')}
          </div>
        )}
        {isLoading && (
          <h6>
            {translate('general.loading')}...{' '}
            <i className="icon icon-update icon-spin-reverse"></i>
          </h6>
        )}
      </div>
    </div>
  );
};

export default QuickOrderAutoComplete;
